import Vue from 'vue'
import axios from 'axios'
import i18n from '@/i18n'

export default {
  baseURL: process.env.BASE_URL + "api/dashboard",

  getDashboard(filter, cancelToken, localizationId) {
    let customProps = this.getCustomPropertyValues(filter);
    return axios
      .get("porsche", {
        baseURL: this.baseURL,
        params: {
          "survey-ids": filter.surveys || null,
          "wave-ids": filter.waves || null,
          "custompropertyvalue-ids": filter.countries || null,
          "clientlocation-ids": filter.clientlocations || null,
          "localization-id": localizationId || i18n.locale
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getApplicationManual(localizationId, documentVariant, cancelToken) {
    return axios
      .get("manual", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "documentvariant": documentVariant
        },
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getCustomPropertyValues(filter) {
    let customProps = '';
    if (!filter)
      return customProps;

    if (!_.isEmpty(filter.country)) {
      customProps = customProps + "|" + filter.country;
    }

    if (!_.isEmpty(customProps)) {
      return customProps.substr(1);
    }

    return customProps;
  },

  getOptions(filter, cancelToken, localizationId) {
    let customProps = this.getCustomPropertyValues(filter);
    return axios
      .get("filters-porsche", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "custompropertyvalue-ids":  !filter ? null : filter.countries || null,
          "client-id": !filter ? null : filter.client || null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
